import React from "react";
import { object, string, z } from "zod";
import { SpecialityType, ValidTypes } from "../enum/authentication";



export const loginSchema = object({
  email: string({ required_error: "Email is required" }).email(
    "Email is invalid"
  ),
  password: string({ required_error: "Password is required" })
    .min(6, "Password must be more than 6 characters")
    .max(32, "Password must be less than 32 characters"),
});

export const forgotPasswordSchemaOne = object({
  email: string({ required_error: "Email is required" }).email(
    "Email is invalid"
  ),
});
export const forgotPasswordSchemaTwo = object({
  code: string({ required_error: "OTP code is required" }).min(
    5,
    "Enter complete OTP"
  ),
});

export const passwordSchema = object({
  password: string({ required_error: "Password is required" })
    .min(6, "Password must be more than 6 characters")
    .max(32, "Password must be less than 32 characters")
    .regex(/^(?=.*[A-Z])(?=.*\d).*$/, {
      message:
        "Password must contain at least one uppercase letter and one numeric digit",
    }),
  passwordConfirm: string({ required_error: "Please confirm your password" }),
}).refine((data) => data.password === data.passwordConfirm, {
  path: ["passwordConfirm"],
  message: "Passwords do not match",
});

export const signUpSchemaOne = object({
  email: string({ required_error: "Email is required" }).email(
    "Email is invalid"
  ),
});
export const signUpSchemaTwo = object({
  code: string({ required_error: "OTP code is required" }).min(
    5,
    "Enter complete OTP"
  ),
});

export const signUpSchemaThree = object({
  name: string({ required_error: "Name is required" }).min(
    2,
    "Name is Incomplete"
  ),
  type: z.nativeEnum(ValidTypes, {
    errorMap: () => ({ message: "Please select a valid option" }),
  }),
  facility_size: string({ required_error: "Size is required" }).min(
    1,
    "Size is required"
  ),
  password: z
    .string()
    .min(6, "Password must be more than 6 characters")
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/,
      {
        message:
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      }
    ),
});

export const verificationSchema = object({
  reg_no: string({
    required_error: "Registration number is required",
  }).min(2, "Number is incomplete"),
  address: string({
    required_error: "Address is required",
  }).min(2, "Kindly input address, street, city"),
  // specialties: z.nativeEnum(SpecialityType, {
  //   errorMap: () => ({ message: "Please select a valid option" }),
  // }),
  // specialties: z.array(z.nativeEnum(SpecialityType, {
  //   errorMap: () => ({ message: "Please select a valid option" }),
  // })),
  // specialties: z.array(z.nativeEnum(SpecialityType)).nonempty({
  //   message: "Please select at least one specialty",
  // }),
  contact_job_title: string({ required_error: "Title is required" }).min(
    2,
    "Title is required"
  ),
  state: string({ required_error: "State is required" }).min(
    1,
    "State is needed"
  ),
  city: string({ required_error: "City is required" }).min(
    2,
    "City is incomplete"
  ),
  contact_email: string({ required_error: "Contact email is required" }).email(
    "Contact email is invalid"
  ),
  contact_name: string({ required_error: "COntact name is required" }).min(
    2,
    "Contact name is Incomplete"
  ),
  phone_number: string({ required_error: "Phone number is required" }).min(
    2,
    "Phone number is required"
  ),
});


